import React, {useContext} from "react";
import {ContentContext} from "../ContentContext";

function Imprint() {
    const data = useContext(ContentContext);

    return (
        <section className={"imprint"}>
            <div dangerouslySetInnerHTML={{__html: data?.imprintContent}} />
        </section>
    );
}

export default Imprint;
